// AccessTokensSettings manages its own local state (PAT list, create flow,
// reveal stage). Wrapping in connect() would require a saga + reducer +
// selector + entity that only serve one settings screen. Direct API calls
// from the component are sufficient and keep the surface area small.
//
// If we ever need PAT state in other parts of the app (e.g., a banner that
// warns "your token is stale"), graduate this to a saga.

import AccessTokensSettings from '../../components/Settings/AccessTokensSettings';

export default AccessTokensSettings;
